// extracted by css-extract-rspack-plugin
export default {"collapse":"collapse-YjHkmt","content":"content-WUn09Y"};